import { RouteRecordRaw } from 'vue-router';

import { checkSharingAuthJwt } from '~/_v3/public-shares/actors/public-shares.http';
import { ExpiredSharesRoute, LoginSharesRoute, PublicSharesRoute } from '~/_v3/public-shares/public-shares.routes';
import { SharesRoute } from '~/_v3/shares/shares.routes';

import { AccountRoute } from '../_v3/account/account.routes';
import { ActivateRedirectRoute, ActivationFranceConnectRoute, ActivationMergeRoute, ActivationRoute } from '../_v3/activation/ui/activation.routes';
import { CollectorsRoute } from '../_v3/collectors/ui/collectors.routes';
import { ResetPasswordRoute } from '../_v3/common/reset-password.routes';
import { DocumentsRoute } from '../_v3/documents/ui/document.routes';
import { FranceConnectRoute } from '../_v3/france-connect/ui/fc.routes';
import { HomeRoute } from '../_v3/home/ui/home.routes';
import { checkJwt } from '../_v3/login/actors/login.http';
import { LoginRoute } from '../_v3/login/ui/login.routes';
import { TrashRoute } from '../_v3/trash/ui/trash.routes';
import { RouteKeys } from './routes.domain';

const FallbackRoute: RouteRecordRaw = {
	name: RouteKeys.NOT_FOUND,
	path: '/:pathMatch(.*)*',
	redirect: HomeRoute,
	meta: {
		public: true
	}
};

const requireAuth = async (_to: any, _from: any, next: any) => {
	try {
		await checkJwt();
		next();
	} catch (error) {
		next({ name: RouteKeys.LOGIN });
	}
};

const requireShareAuth = async (_to: any, _from: any, next: any) => {
	try {
		await checkSharingAuthJwt();
		next();
	} catch (error) {
		const token = localStorage.getItem('sharingCodeToken');
		next({
			path: '/public/sharings',
			query: { token }
		});
	}
};

export const routes: RouteRecordRaw[] = [
	{
		...HomeRoute,
		beforeEnter: requireAuth
	},
	{
		...FallbackRoute,
		beforeEnter: requireAuth
	},
	{
		...ActivateRedirectRoute,
		meta: { public: true }
	},
	{
		...ActivationRoute,
		meta: { public: true }
	},
	{
		...ActivationFranceConnectRoute,
		meta: { public: true }
	},
	{
		...ActivationMergeRoute,
		meta: { public: true }
	},
	{
		...DocumentsRoute,
		beforeEnter: requireAuth
	},
	{
		...LoginRoute,
		meta: { public: true }
	},
	{
		...FranceConnectRoute,
		meta: { public: true }
	},
	{
		...SharesRoute,
		beforeEnter: requireAuth
	},
	{
		...LoginSharesRoute,
		meta: { public: true }
	},
	{
		...PublicSharesRoute,
		beforeEnter: requireShareAuth
	},
	{
		...ExpiredSharesRoute
	},
	{ ...CollectorsRoute, beforeEnter: requireAuth },
	{
		...TrashRoute,
		beforeEnter: requireAuth
	},
	{
		...AccountRoute,
		beforeEnter: requireAuth
	},
	ResetPasswordRoute
];
